export var phasesConfigValues = {
  SEND_ON_START: 'SEND_ON_START',
  SEND_ON_FINISH: 'SEND_START_AND_FINISH',
  SEND_ON_APP_LOADED: 'SEND_ON_START',
  SEND_START_AND_FINISH: 'SEND_START_AND_FINISH'
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/fedops-logger/dist/es/src/loading-phases/loading-phases-config.js
// module id = 128
// module chunks = 0 1